
import { Shield, Bug } from 'lucide-react';

const SecurityFooter = () => {
  return (
    <div className="bg-gray-900 text-white py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <Shield size={16} className="text-green-400" />
              <span className="text-sm font-medium">Secure by Design</span>
            </div>
            <div className="text-xs text-gray-400">
              Security Verified • SSL Encrypted
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <a 
              href="mailto:security@zimkonnect.com?subject=Security%20Bug%20Report" 
              className="flex items-center space-x-1 text-sm text-blue-400 hover:text-blue-300 transition-colors"
            >
              <Bug size={14} />
              <span>Report Security Issue</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityFooter;
